import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { fetchBrands, fetchVenues, fetchBrandVenues, MERCHANT_ENTERPRISE_SERVICE } from 'apis/enterprise/api';
import { BrandItem } from 'apis/enterprise/types';

import { useEnterpriseContext } from '../context/EnterpriseContext';
import type { BrandVenues } from '../types';

export default function useGetEnterpriseVenues() {
  const [brandsVenues, setBrandsVenues] = useState<BrandVenues[] | null>(null);
  const [error, setError] = useState(null);
  const { enterprise } = useEnterpriseContext();

  const { data: brands } = useQuery(
    [`${MERCHANT_ENTERPRISE_SERVICE}/enterprises/${enterprise?.id}/brands`],
    () => enterprise && fetchBrands(enterprise?.id),
    {
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    async function fetchVenuesData(brands: BrandItem[]) {
      try {
        const venuesBrands = await Promise.all(
          brands.map(async item => {
            const venues = await fetchBrandVenues(item.brand.id);
            return {
              brand: item.brand,
              venuesIds: venues.map(item => item.venueId),
            };
          }),
        );

        const brandItemsWithVenues = venuesBrands.filter(item => item.venuesIds.length);

        const brandsVenues: BrandVenues[] = await Promise.all(
          brandItemsWithVenues.map(async brandItem => {
            const { venuesIds, brand } = brandItem;
            const { results: venues } = await fetchVenues(venuesIds);

            return {
              brand,
              venues,
            };
          }),
        );
        setBrandsVenues(brandsVenues);
      } catch (error) {
        setError(error);
      }
    }

    if (brands) {
      fetchVenuesData(brands);
    }
  }, [brands]);

  return { brandsVenues, error };
}
